export const ExternalApps = {
  TIMELAPSE: 'TimeLapse',
  IOSIM_PLUS: 'IOSim Pro'
};
